module.exports = __webpack_public_path__ + "static/media/client37.76d4ceda.jpg";